import { money } from "../../utilities/currency";

/** English */
const en = {
  home: {
    offer: "✨ Special offer – Pay 99 kr, get 198 kr in call credit! ✨",
    signIn: "Log in",
    join: "Join",
    allAdvisors: "All advisors",
    festivalTitle: "Festival campaigns",
    referTitle: "Get your first consultation free!",
    referBody:
      "Book a 15-minute free call. Perfect for finding the right advisor – safe, digital and with no obligations.",
    blogTitle: "From the Mystic blog",
    viewAll: "See all",
    subscribeLine: "Get new guides and offers by email.",
    read: "Read",
    invite: "Book a free consultation",
    sponsored: "Sponsored",
    ad: (n) => `Ad ${n}`,
    adBlurb: "Advertise products, apps or events here.",
    learnMore: "Learn more",
    connectNow: "Connect now",
    from: "from",
    minutes: "min",
    verified: "Verified",
    categories: [
      "Love reading",
      "Clairvoyant reading",
      "Tarot reading",
      "Astrology & Horoscope",
      "Angel messages",
      "Oracle guidance",
      "Dream interpretation",
      "Spiritual medium",
    ],
    hero: {
      name: "The Advisors",
      tag: "Love expert",
      blurb:
        "My promise: I am here for you. When it's hard to know who to trust, genuine presence is everything.",
      getReading: "Book a consultation",
    },
    footer: {
      getApp: "Get the app for clarity wherever you are.",
      explore: "Explore",
      special: "Specialties",
      more: "More",
      advisors: "Advisors",
      blog: "Our blog",
      applyCode: "Use promo code",
      support: "Customer support",
      about: "About us",
      apply: "Advisor? Apply here",
      privacy: "Privacy",
      terms: "Terms",
    },
    wallet: {
      title: "Buy call minutes",
      intro:
        "Minutes are stored in your Mystic wallet and can be used with any advisor (chat / call / video).",
      numLabel: "The phone number you call from",
      amount: "Choose amount",
      buy: (amt) => `Buy ${money(amt)} credit`,
      learn: "Read more about payment methods",
      err: "Enter a valid phone number",
      otp: (n) => `Code sent to ${n}. Enter it to confirm.`,
      enterOtp: "Enter code",
      verify: "Confirm & add credit",
      cancel: "Cancel",
      success: (amt) => `${money(amt)} added to your wallet!`,
      pm1: "Vipps MobilePay",
      pm2: "Card (requires registration on your mobile number)",
      nolgin: "No login required for Vipps MobilePay – call directly.",
    },
  },

  header: {
    hello: "Hi",
    logout: "Log out",
    login: "Log in",
  },

  footer: {
    categories: [
      "Dummy 1",
      "Dummy 2",
      "Dummy 3",
      "Dummy 4",
      "Dummy 5",
      "Dummy 6",
      "Dummy 7",
      "Dummy 8",
    ],
    paymentMethods: "Payment methods",
    footer: {
      getApp: "Get the app for clarity wherever you are.",
      explore: "Explore",
      special: "Specialties",
      more: "More",
      advisors: "Advisors",
      blog: "Our blog",
      applyCode: "Use promo code",
      support: "Customer support",
      about: "About us",
      apply: "Advisor? Apply here",
      privacy: "Privacy",
      terms: "Terms",
    },
  },
};

export default en;
